var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-autocomplete", {
    attrs: {
      id: "tenantlists",
      outlined: "",
      "background-color": _vm.bgcolor,
      color: _vm.textFieldOutline,
      label: _vm.label,
      items: _vm.valuesList,
      "item-value": "key",
      "item-text": "value",
      multiple: "",
      chips: ""
    },
    scopedSlots: _vm._u([
      {
        key: "prepend-item",
        fn: function() {
          return [
            _c(
              "v-list-item",
              {
                attrs: { ripple: "" },
                on: {
                  mousedown: function($event) {
                    $event.preventDefault()
                  },
                  click: function($event) {
                    return _vm.selectAll()
                  }
                }
              },
              [
                _c(
                  "v-list-item-action",
                  [
                    _vm.selectAllStatus
                      ? _c("v-icon", { attrs: { color: "primary" } }, [
                          _vm._v("check_box")
                        ])
                      : _c("v-icon", [_vm._v("check_box_outline_blank")])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-list-item-content",
                  [
                    _c("v-list-item-title", [
                      _vm._v(
                        "\n                    Select All\n                "
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("v-divider", { staticClass: "mt-2" })
          ]
        },
        proxy: true
      },
      {
        key: "selection",
        fn: function(ref) {
          var item = ref.item
          var index = ref.index
          return [
            index <= 0
              ? _c(
                  "v-chip",
                  {
                    staticClass: "chipsclass",
                    attrs: { small: "", title: item.value }
                  },
                  [_c("span", [_vm._v(_vm._s(item.value))])]
                )
              : _vm._e(),
            _vm._v(" "),
            index === 1
              ? _c("span", { staticClass: "grey--text text-caption" }, [
                  _vm._v(
                    "\n        (+" +
                      _vm._s(_vm.selectedList.length - 1) +
                      ")\n        "
                  )
                ])
              : _vm._e()
          ]
        }
      }
    ]),
    model: {
      value: _vm.selectedList,
      callback: function($$v) {
        _vm.selectedList = $$v
      },
      expression: "selectedList"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }